(() => {
  const requests = new Map();
  const unique = xs => [...new Set(xs)].sort((a,b) => String(a).localeCompare(String(b),undefined,{numeric:true}));
  const applicationMatches = (a,s) => a[0] === s.make && a[1] === s.model &&
    (s.year === 'all' || (Number.isInteger(a[2]) && Number.isInteger(a[3]) && +s.year >= a[2] && +s.year <= a[3])) &&
    (s.chassis === 'all' || a[4].includes(s.chassis));
  const matchingProducts = (products,s) => products.filter(p => p.applications.some(a => applicationMatches(a,s)));
  if (typeof module !== 'undefined' && module.exports) module.exports = {applicationMatches,matchingProducts};
  if (typeof document === 'undefined') return;
  const fetchJSON = url => {
    if (!requests.has(url)) requests.set(url,(async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(),20000);
      try {
        const response = await fetch(url,{credentials:'same-origin',signal:controller.signal});
        if (!response.ok) throw new Error('Request failed');
        return await response.json();
      } finally {clearTimeout(timer);}
    })().catch(error => {requests.delete(url);throw error;}));
    return requests.get(url);
  };
  const init = root => {
    if (root.dataset.vfReady) return;
    root.dataset.vfReady = 'true';
    const t = JSON.parse(root.querySelector('[data-vf-translations]').textContent);
    const form = root.querySelector('form');
    const fields = Object.fromEntries(['make','model','year','chassis'].map(k=>[k,form.elements['vf_'+k]]));
    const submit = form.querySelector('[type="submit"]');
    const status = root.querySelector('.jdm-vf__status');
    let products,applications,loading,run=0;
    const results = document.createElement('div');
    results.className='jdm-vf-results';results.hidden=true;results.setAttribute('aria-live','polite');
    root.querySelector('.jdm-vf__inner').append(results);
    const selection = () => Object.fromEntries(Object.entries(fields).map(([k,f])=>[k,f.value]));
    const options = (select,values,placeholder) => {
      select.replaceChildren(new Option(placeholder,''));
      values.forEach(v=>select.add(new Option(v.label??v,v.value??v)));
      select.disabled=!values.length;
    };
    const ready = () => {submit.disabled=Object.values(fields).some(f=>!f.value);form.elements.q.value='';};
    const vehicleRows = () => applications.filter(a=>a[0]===fields.make.value && a[1]===fields.model.value);
    const updateChassis = () => {
      const rows=vehicleRows().filter(a=>fields.year.value==='all'||(Number.isInteger(a[2])&&+fields.year.value>=a[2]&&+fields.year.value<=a[3]));
      const values=unique(rows.flatMap(a=>a[4]));
      options(fields.chassis,[{value:'all',label:t.allChassis},...values],t.chooseChassis);
      fields.chassis.value=values.length===1?values[0]:'all';ready();
    };
    const updateYears = () => {
      const years=[];vehicleRows().forEach(a=>{if(Number.isInteger(a[2])&&Number.isInteger(a[3]))for(let y=a[2];y<=Math.min(a[3],new Date().getFullYear()+1);y++)years.push(String(y));});
      options(fields.year,[{value:'all',label:t.allYears},...unique(years).reverse()],t.chooseYear);
      fields.year.value='all';updateChassis();
    };
    const updateModels = () => {
      options(fields.model,unique(applications.filter(a=>a[0]===fields.make.value).map(a=>a[1])),t.chooseModel);
      options(fields.year,[],t.chooseYear);options(fields.chassis,[],t.chooseChassis);ready();
    };
    const element = (tag,text,className) => {const el=document.createElement(tag);if(text)el.textContent=text;if(className)el.className=className;return el;};
    const productLink = handle => {
      const url=new URL((window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(handle),location.origin);
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url;
    };
    const showResults = async (page=0) => {
      if(!products||submit.disabled)return;
      const token=++run,s=selection(),matches=matchingProducts(products,s),size=12;
      results.hidden=false;results.replaceChildren();
      const heading=element('h3',t.resultsHeading);heading.tabIndex=-1;results.append(heading);
      results.append(element('p',`${s.make} ${s.model} · ${s.year==='all'?t.allYears:s.year} · ${s.chassis==='all'?t.allChassis:s.chassis}`));
      const count=element('p',t.resultsCount.replace('__COUNT__',String(matches.length)));results.append(count);
      if(location.pathname.includes('/search'))document.querySelectorAll('[id$="__search-template"]').forEach(el=>el.hidden=true);
      if(!matches.length){results.append(element('p',t.noMatches));heading.focus({preventScroll:true});return;}
      const grid=element('div','', 'jdm-vf-results__grid');results.append(grid);
      let cursor=0;const entries=matches.slice(page*size,(page+1)*size);
      const cards=entries.map(p=>{
        const card=element('article','', 'jdm-vf-results__card');
        const title=element('a',p.title);title.href=productLink(p.handle).href;
        const vendor=element('p',p.vendor,'jdm-vf-results__vendor');
        const info=element('p',t.loading);card.append(title,vendor,info);grid.append(card);return {p,card,title,info};
      });
      const worker=async()=>{while(cursor<cards.length){const {p,card,title,info}=cards[cursor++];try{
        const url=productLink(p.handle);url.pathname+='.js';
        const live=await fetchJSON(url.href);if(token!==run)return;
        if(!live||!live.title||!Array.isArray(live.variants))throw new Error('Unavailable');
        title.textContent=live.title;
        if(live.featured_image){const link=element('a');link.href=title.href;link.tabIndex=-1;link.setAttribute('aria-hidden','true');const img=element('img');img.src=live.featured_image;img.alt='';img.loading='lazy';img.width=320;img.height=240;link.append(img);card.prepend(link);}
        const currency=window.Shopify?.currency?.active||'AUD';
        info.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency}).format(live.price_min/100)+(live.available?'':` · ${t.outOfStock}`);
        const view=element('a',t.viewProduct,'jdm-vf-results__view');view.href=title.href;card.append(view);
      }catch{if(token===run){info.textContent=t.productUnavailable;card.remove();}}}};
      await Promise.all(Array.from({length:Math.min(4,cards.length)},worker));if(token!==run)return;
      const nav=element('nav','', 'jdm-vf-results__pagination');nav.setAttribute('aria-label',t.pagination);
      if(page>0){const b=element('button',t.previous);b.type='button';b.onclick=()=>showResults(page-1);nav.append(b);}
      if((page+1)*size<matches.length){const b=element('button',t.next);b.type='button';b.onclick=()=>showResults(page+1);nav.append(b);}
      if(nav.childElementCount)results.append(nav);
      heading.focus({preventScroll:true});
      if(location.pathname.includes('/search'))document.querySelectorAll('[id$="__search-template"]').forEach(el=>el.hidden=true);
    };
    const saveAndSearch = async () => {
      ready();if(submit.disabled)return;const s=selection();
      try{sessionStorage.setItem('jdmVehicle',JSON.stringify(s));}catch{}
      const url=new URL(location.href);['q','type'].forEach(k=>url.searchParams.delete(k));
      Object.entries(s).forEach(([k,v])=>url.searchParams.set('vf_'+k,v));
      url.hash='find-your-vehicle';history.pushState(null,'',url);await showResults();
    };
    const restore = async () => {
      const url=new URL(location.href);let saved;
      if(url.searchParams.has('vf_make'))saved=Object.fromEntries(['make','model','year','chassis'].map(k=>[k,url.searchParams.get('vf_'+k)||'all']));
      else try{saved=JSON.parse(sessionStorage.getItem('jdmVehicle')||'null');}catch{}
      if(!saved)return;fields.make.value=saved.make;if(!fields.make.value)return;
      updateModels();fields.model.value=saved.model;if(!fields.model.value)return;
      updateYears();if([...fields.year.options].some(o=>o.value===saved.year))fields.year.value=saved.year;
      updateChassis();if([...fields.chassis.options].some(o=>o.value===saved.chassis))fields.chassis.value=saved.chassis;
      ready();if(url.searchParams.has('vf_make')||root.dataset.legacyResults==='true')await showResults();
    };
    const load = async () => {
      if(products)return products;if(loading)return loading;status.textContent=t.loading;fields.make.disabled=true;
      loading=(async()=>{try{
        let data=await fetchJSON(root.dataset.fitment);
        if(Array.isArray(data.shards)){
          const base=new URL(root.dataset.fitment,location.href);
          const parts=await Promise.all(data.shards.map(name=>fetchJSON(new URL(name,base).href)));
          if(parts.some(part=>!Array.isArray(part.products)))throw new Error('Invalid fitment data');
          data={products:parts.flatMap(part=>part.products)};
        }
        if(!Array.isArray(data.products))throw new Error('Invalid data');
        products=data.products;applications=products.flatMap(p=>p.applications);
        options(fields.make,unique(applications.map(a=>a[0])),t.chooseMake);status.textContent='';await restore();return products;
      }catch{loading=null;fields.make.disabled=false;status.textContent=t.loadError;return null;}})();return loading;
    };
    fields.make.addEventListener('focus',load);form.addEventListener('pointerdown',()=>void load(),{passive:true});
    fields.make.addEventListener('change',async()=>{await load();if(products)updateModels();});
    fields.model.addEventListener('change',updateYears);fields.year.addEventListener('change',updateChassis);fields.chassis.addEventListener('change',ready);
    form.addEventListener('submit',async e=>{e.preventDefault();await load();if(products&&form.reportValidity())await saveAndSearch();});
    root.querySelector('.jdm-vf__reset').addEventListener('click',()=>{++run;fields.make.value='';if(products)updateModels();results.hidden=true;results.replaceChildren();status.textContent='';try{sessionStorage.removeItem('jdmVehicle');}catch{}const url=new URL(location.href);['make','model','year','chassis','engine','application','incomplete'].forEach(k=>url.searchParams.delete('vf_'+k));history.replaceState(null,'',url);});
    if(root.dataset.legacyResults==='true'||new URL(location.href).searchParams.has('vf_make'))void load();
    else if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();void load();}},{rootMargin:'150px'});observer.observe(root);}else void load();
    window.addEventListener('popstate',()=>{if(!new URL(location.href).searchParams.has('vf_make')){++run;results.hidden=true;}else if(products)void restore();});
  };
  const start=()=>document.querySelectorAll('[data-jdm-vehicle-finder]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
